import { inject, Injectable } from '@angular/core';

import { HeaderHttpService } from '../http/http.service';
import { Subscription, tap } from 'rxjs';
import { MenuItem } from '../../model/header.model';

@Injectable()
export class HeaderMenuService {
    private readonly headerHttpService = inject(HeaderHttpService);
    private _items: MenuItem[] = [];

    private readonly susbsriptions$: Subscription = new Subscription();

    init(): void {
        this.susbsriptions$.add(
            this.headerHttpService
                .getHeaderMenuItems()
                .pipe(tap((items) => (this._items = items)))
                .subscribe(),
        );
    }

    destroy(): void {
        this.susbsriptions$.unsubscribe();
    }

    get items(): MenuItem[] {
        return this._items;
    }
}
